import { CountryDataItemRowItem, ReportTableHeaders } from '@/models/report/report.model';
import TableColumn from 'element-plus/lib/components/table/src/tableColumn';
import { GroupByDate } from '@/models/app-common/app-common.model';
import { formatUnixToString } from '@marfa/bo-utils';

export type RealMoneyBalancePlayerListResponseModel = {
  data: RealMoneyBalancePlayerListItemModel[];
  headers: Record<string, string>;
};

export type RealMoneyBalancePlayerListFilterModel = {
  dateFrom?: string;
  dateTo?: string;
  playerId?: string;
  exchangeRateDate?: string;
}

export type RealMoneyBalancePlayerListRequestModel = {
  groupByDate?: GroupByDate;
  dateFrom?: string;
  dateTo?: string;
  exchangeRateDate?: string;
  playerId?: string;
  sort?: string;
  limit?: number;
  offset?: number;
  filterList?: RealMoneyBalancePlayerListFilterModel;
}

export type RealMoneyBalancePlayerListItemModel = {
  playerId: string;
  ggr: string;
  aggregateDate: number;
  betsSum: string;
  winsSum: string;
  betsRealSum: string;
  winsRealSum: string;
  betsBonusSum: string;
  winsBonusSum: string;
  realGgr: string;
  bonusGgr: string;
  moneyBalance: string;
  bonusBalance: string;
}

export enum RealMoneyBalancePlayerTableHeaders {
  PLAYER_ID = 'playerId',
  GGR = 'ggr',
  AGGREGATE_DATE = 'aggregateDate',
  BETS_SUM = 'betsSum',
  WINS_SUM = 'winsSum',
  BETS_REAL_SUM = 'betsRealSum',
  WINS_REAL_SUM = 'winsRealSum',
  BETS_BONUS_SUM = 'betsBonusSum',
  WINS_BONUS_SUM = 'winsBonusSum',
  REAL_GGR = 'realGgr',
  BONUS_GGR = 'bonusGgr',
  MONEY_BALANCE = 'moneyBalance',
  BONUS_BALANCE = 'bonusBalance',
}

export const realMoneyBalancePlayerTable: Partial<typeof TableColumn> = [
  {
    label: 'Player ID',
    prop: RealMoneyBalancePlayerTableHeaders.PLAYER_ID,
    width: '160',
    sortable: true,
  },
  {
    label: 'Money Balance',
    prop: RealMoneyBalancePlayerTableHeaders.MONEY_BALANCE,
    width: '110',
    sortable: false,
  },
  {
    label: 'Bonus Balance',
    prop: RealMoneyBalancePlayerTableHeaders.BONUS_BALANCE,
    width: '110',
    sortable: false,
  },
  {
    label: 'Aggregate date',
    prop: RealMoneyBalancePlayerTableHeaders.AGGREGATE_DATE,
    width: '135',
    formatter: (row: CountryDataItemRowItem) => formatUnixToString(row[ReportTableHeaders.AGGREGATE_DATE], true),
    sortable: true,
  },
  {
    label: 'Bets sum',
    prop: RealMoneyBalancePlayerTableHeaders.BETS_SUM,
    width: '100',
    sortable: true,
  },
  {
    label: 'Wins sum',
    prop: RealMoneyBalancePlayerTableHeaders.WINS_SUM,
    width: '100',
    sortable: true,
  },
  {
    label: 'Bets real sum',
    prop: RealMoneyBalancePlayerTableHeaders.BETS_REAL_SUM,
    width: '135',
    sortable: true,
  },
  {
    label: 'Wins real sum',
    prop: RealMoneyBalancePlayerTableHeaders.WINS_REAL_SUM,
    width: '135',
    sortable: true,
  },
  {
    label: 'Bets bonus sum',
    prop: RealMoneyBalancePlayerTableHeaders.BETS_BONUS_SUM,
    width: '135',
    sortable: true,
  },
  {
    label: 'Wins bonus sum',
    prop: RealMoneyBalancePlayerTableHeaders.WINS_BONUS_SUM,
    width: '135',
    sortable: true,
  },
  {
    label: 'Real GGR',
    prop: RealMoneyBalancePlayerTableHeaders.REAL_GGR,
    width: '100',
    sortable: true,
  },
  {
    label: 'Bonus GGR',
    prop: RealMoneyBalancePlayerTableHeaders.BONUS_GGR,
    width: '110',
    sortable: true,
  },
  {
    label: 'GGR',
    prop: RealMoneyBalancePlayerTableHeaders.GGR,
    sortable: true,
  },
];
